exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-wrapper[data-v-3ccc8029]{position:relative;height:400px;background:linear-gradient(135deg,#fff,#f8f9fa);border-radius:12px;padding:20px;box-shadow:0 4px 20px rgba(13,99,72,.1);border:1px solid rgba(13,99,72,.1)}", ""]);

// exports
